// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
import account from '@/api/v1/account';
import Qs from 'qs';
import moment from 'moment';
import EventBus from '@/event-bus';
import linkify from 'vue-linkify';

import Twemoji from '@/components/Messages/Twemoji';
import ClipLoader from 'vue-spinner/src/ClipLoader';
import 'bootstrap/dist/css/bootstrap.css';
import BootstrapVue from 'bootstrap-vue';
import 'vue-material-design-icons/styles.css';

import App from './App';
import router from './router';

Vue.config.productionTip = false;

Vue.component('clip-loader', ClipLoader);
Vue.component('twemoji', Twemoji);

Vue.directive('linkified', linkify);

Vue.use(BootstrapVue);

// Attach event bus to the Vue global object
Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return EventBus;
    },
  },
  $current_user: {
    get() {
      return account.user;
    },
  },
});

// Axios
axios.defaults.baseURL = process.env.API_URL;
axios.defaults.headers.common['mogree-Access-Id'] = account.user.accessId;
axios.defaults.paramsSerializer = params => Qs.stringify(params, { arrayFormat: 'repeat' });
axios.defaults.withCredentials = true;

Vue.filter('formatDate', value => moment(value).format('DD.MM.YYYY. - HH:mm'));
Vue.filter('absentDate', value => moment(value).format('DD.MM.YYYY'));
Vue.filter('charsLeft', (value, maxlength) => `${value.length} / ${maxlength} Zeichen`);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js